import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from '../../environments/environment';

export interface OperationsDashboard {
  projectId: number;
  projectName?: string;
  rigName?: string;
  jobType?: string;
  projectLastUpdateDate: Date;
  projectLastUpdateDateString?: string;
  projectAlertClass?: string;

  slurryId: number;
  slurryName?: string;
  slurryNotes?: string;
  slurryLastUpdateDate: Date;
  slurryLastUpdateDateString?: string;
  slurryAlertClass?: string;

  testId: number;
  testInputID?: number;
  testInputTypeName?: string;
  testInputTypeSortOrder: number;
  testInputStatusName?: string;
  testInputStatusClass?: string;
  testLastUpdateDate: Date;
  testLastUpdateDateString?: string;
  testAlertClass?: string;

  lastUpdateDate: Date;
}


@Injectable({
  providedIn: 'root'
})
export class OperationsDashboardService {
  constructor(private http: HttpClient) {}

  private apiUrl = `${environment.apiUrl}/operations-dashboard`;

  getOperationsDashboard(): Observable<OperationsDashboard[]> {
    return this.http.get<OperationsDashboard[]>(`${this.apiUrl}/operations`);
  }

  getDashboardAlertsForComputer(computerName: string): Observable<OperationsDashboard[]> {
    return this.http.get<OperationsDashboard[]>(`${this.apiUrl}/operations/${encodeURIComponent(computerName)}`);
  }

  clearDashboardAlertsForComputer(computerName: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/operations/clear/${encodeURIComponent(computerName)}`);
  }
}